import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const siteContextMonitoringSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
})
